<template>
    <div class="app-container" style="background:#f9f9f9">
        <!-- 工具栏 收搜 -->
        <toolbar-task ref="toolbar" source="myCreate" @filter="handleFilter"></toolbar-task>

        <el-button type="primary" size="mini" @click="handleJump" style="margin: -10px 0 10px;" v-if="accessPoint['applyme:create']">发起申请</el-button>

        <!-- 列表 -->
        <table-list ref="table" :status="status" @paginationList="getList" @againList="handleFilter"></table-list>
    </div>
</template>

<script>
import ToolbarTask from './components/toolbarTask'
import TableList from './components/tableList'
import { artFlowList_ajax } from '@File~/api/file'
export default {
    components: {ToolbarTask,TableList},
    data() {
        return {
            status:'',
            accessPoint: this.$store.getters.accessPoint, //权限点
        }
    },
    mounted() {
        this.getList()
    },

    methods: {
        // 获取列表
        getList() {
            const toolbar = this.$refs['toolbar']
            const table = this.$refs['table']
            table.listLoading = true

            this.status = toolbar.status

            const data = {
                pageNo: table.listQuery.pageNo,
                pageSize: table.listQuery.pageSize,
                orderByTypeStr: table.sortType ? table.sortProperty + ' ' + table.sortType : 'createTime DESC',
                keyword: toolbar.search,
                createTime: toolbar.createTimes && toolbar.createTimes.length > 0 ? toolbar.createTimes[0] + ' - ' + toolbar.createTimes[1] : '',
                completeTime:toolbar.finishTimes && toolbar.finishTimes.length > 0 ? toolbar.finishTimes[0] + ' - ' + toolbar.finishTimes[1] : '',
                projectIds: toolbar.projectIds,
                designerIds: toolbar.designerIds,
                priority: toolbar.priority,
                status: toolbar.status,
                taskIds:toolbar.putValue ? toolbar.putValue : [],
                createUserId:this.$store.getters.userId,
                share:toolbar.share,
                roleIds: this.$store.getters.roles,
                taskTypeIds:toolbar.taskTypeIds
            }
            artFlowList_ajax(data).then(response => {
                table.listLoading = false
                if(response.code == 1) {
                    table.total = response.data.totalCount
                    const data = JSON.parse(JSON.stringify(response.data.result))
                    table.tableData = data.map(v => {
                        if(this.$store.getters.userId == v.createUserId && v.status == 0) { // 待分配
                            this.$set(v, 'isBackout', true) // 撤销按钮
                        }
                        if(this.$store.getters.userId == v.createUserId) {
                            this.$set(v, 'isShare', true)
                        }
                        return v
                    })
                }
            })
        },

        // 查询
        handleFilter() {
            this.$refs['table'].listQuery.pageNo = 1
            this.getList()
        },

        // 跳转
        handleJump() {
            this.$router.push({path: '/taskCenter/create'}) // 跳转任务池
        }
    }
}
</script>

<style lang="scss" scoped>
  
</style>